import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import CategorySelect from '../../generic/CategorySelect';
import createModalToggle from '../../generic/create-modal-toggle';
import DatePicker from '../../generic/DatePicker';
import { getMomentDate } from '../../utils/date-helpers';

class ChangeRequestBulkEditor extends React.Component {
  state = {
    startDate: null,
    endDate: null,
    categories: [],
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleUpdate = field => {
    const { onChange, selectedItems } = this.props;
    selectedItems.map(item => {
      return onChange({
        target: {
          name: `campaignLines.${item}.${field}`,
          value: this.state[field],
        },
      });
    });
  };

  render() {
    const { toggle } = this.props;
    const { startDate, endDate, categories } = this.state;

    return (
      <>
        <ModalHeader toggle={toggle}>Edit the selected lines</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row className="align-items-center">
              <Label for="bulk.startDate" sm={2}>
                Dates
              </Label>
              <Col sm={8}>
                <DatePicker
                  id="bulk.startDate"
                  name="startDate"
                  value={startDate}
                  onChange={this.handleChange}
                />
                <span className="px-1">-</span>
                <DatePicker
                  id="bulk.endDate"
                  name="endDate"
                  value={endDate}
                  onChange={this.handleChange}
                  initialVisibleMonth={() => getMomentDate(startDate)}
                />
              </Col>
              <Col sm={2}>
                <Button
                  onClick={() => {
                    if (startDate) this.handleUpdate('startDate');
                    if (endDate) this.handleUpdate('endDate');
                  }}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="bulk.categories" sm={2}>
                Categories
              </Label>
              <Col sm={8}>
                <CategorySelect
                  id="bulk.categories"
                  name="categories"
                  value={categories}
                  className="c-campaign-line-select"
                  onChange={this.handleChange}
                />
              </Col>
              <Col sm={2}>
                <Button onClick={() => this.handleUpdate('categories')}>
                  Update
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
      </>
    );
  }
}

ChangeRequestBulkEditor.propTypes = {
  selectedItems: arrayOf(string).isRequired,
  toggle: func.isRequired,
  onChange: func.isRequired,
};

export default createModalToggle(
  'Edit selected lines',
  ChangeRequestBulkEditor,
  { outline: true },
  { size: 'lg' },
);
